import { ReactNode } from 'react';
import {
    Control,
    FieldValues,
    useFormContext,
    useFormState,
} from 'react-hook-form';
import { InputError, InputErrorProps } from './InputError';
import { InputHint, InputHintProps } from './InputHint';

export type InputHintErrorProps = InputHintProps & InputErrorProps;

interface InputHintErrorContentProps extends InputHintErrorProps {
    isSubmitted?: boolean;
}

interface SubmittedInputHintErrorProps extends InputHintErrorProps {
    control: Control<FieldValues>;
}

function InputHintErrorContent({
    isSubmitted,
    ...props
}: InputHintErrorContentProps): ReactNode {
    const inputError = <InputError {...props} />;
    const hasTouchedError =
        props.fieldState?.error && props.fieldState?.isTouched;
    const hasSubmittedError = props.fieldState?.error && isSubmitted;
    if (props.errorMessage || hasTouchedError || hasSubmittedError) {
        return inputError;
    }

    return <InputHint {...props} />;
}

function SubmittedInputHintError({
    control,
    ...props
}: SubmittedInputHintErrorProps): ReactNode {
    const { isSubmitted } = useFormState({
        control,
    });

    return <InputHintErrorContent {...props} isSubmitted={isSubmitted} />;
}

export function InputHintError(props: InputHintErrorProps): ReactNode {
    const formContext = useFormContext();

    if (formContext) {
        return (
            <SubmittedInputHintError {...props} control={formContext.control} />
        );
    }

    return <InputHintErrorContent {...props} />;
}
